import React from 'react';
import AriaLiveRegion from '../AriaLiveRegion';

function SelectInput({index, inputField, handleSelectChange, handleMouseEnter, handleMouseLeave, hoveredIndex, windowWidth, pageHeight, pageWidth }) {
    const hasError = !inputField.valid;
    const errorId = hasError ? `error-${inputField.editor.inputType.value}-${index}` : undefined;
    const fieldLabel = inputField.editor.inputType.label || inputField.editor.inputType.value;

    // Error message for screen readers
    const errorMessage = hasError ? `שדה בחירה ${fieldLabel} דורש תיקון` : '';

    // CRITICAL FIX: Calculate rendered PDF height correctly
    const renderedHeight = windowWidth * (pageHeight / pageWidth);
    const fieldHeight = windowWidth * inputField.editor.height / 40;

    return (
      <>
      <select
        style={{
          opacity: `${hoveredIndex === index || inputField.editor.state ? 0.8 : 1}`,
          position: 'absolute',
          top: inputField.y * renderedHeight,
          left: inputField.x * windowWidth,
          width: `${(windowWidth * inputField.editor.width / 1.5)}px`,
          height: `${fieldHeight}px`,
          fontSize: `${windowWidth / 60}px`,
          border: `${inputField.valid? '1px solid #ccc':'2px solid red'}`
        }}
        value={inputField.value}
        onChange={(event) => handleSelectChange(event, index)}
        aria-label={fieldLabel}
        aria-invalid={hasError}
        aria-describedby={errorId}
        aria-required={inputField.mandatory ? 'true' : 'false'}
        displayEmpty
        onMouseEnter={(event) => handleMouseEnter(event, index)}
        onMouseLeave={handleMouseLeave}
      >
        <option value="" style={{ fontSize: `${windowWidth / 60}px` }} disabled>
          -- בחר אופציה --
        </option>
        {inputField.options.map((input, inputIndex) => (
          <option style={{ fontSize: `${windowWidth / 60}px` }} key={inputIndex} value={input}>
            {input || 'בחר אופציה'} {/* Display 'Empty Input' if the input is an empty string */}
          </option>
        ))}
      </select>
      {hasError && (
        <AriaLiveRegion
          id={errorId}
          message={errorMessage}
          type="error"
          visible={false}
          sx={{
            position: 'absolute',
            top: inputField.y * renderedHeight + fieldHeight + 2,
            left: inputField.x * windowWidth,
            fontSize: `${windowWidth / 80}px`,
            color: '#ef4444',
            pointerEvents: 'none',
          }}
        />
      )}
    </>
    );
}

export default SelectInput;
